export default __webpack_public_path__ + "static/media/select_game_computer.2aea05ce.png";